import { makeAutoObservable, toJS } from "mobx";
import AppStore from "../stores/AppStore";


  // Update IPersonalDevelopment interface to include qualifications
  export interface IPersonalDevelopment {
    id: string;
    careerGoals: string; // Define your career goals
    skillDevelopment: string; // Describe your skill development plan
    improvementAreas: string; // List your improvement areas
    actionItems: string; // Define actionable steps
    leadershipValues: string; // Define your leadership values
    skillImprovement: string; // Outline skill improvement actions
    supervisorId: string; // Define your leadership values
    uid: string;
    dateSubmitted: number;
    dateCreated: number;
    type: IType;
  
    gender:IGender // Array to hold qualifications
  }
  
  // Default personal development object
  export const defaultPersonalDevelopment: IPersonalDevelopment = {
      id: "",
      uid: "",
      dateCreated: 0,
      dateSubmitted: 0,
      supervisorId: "",
      careerGoals: "",
      skillDevelopment: "",
      improvementAreas: "",
      actionItems: "",
      leadershipValues: "",
      skillImprovement: "",
      type: "Profile",
    
      gender: "Female"
  };
  
export type IType = "Profile"|"Request Coarse" ;
export type IGender = "Female"|"Male" ;


export default class PersonalDevelopment {
    private personalDevelopment: IPersonalDevelopment;

    constructor(private store: AppStore, personalDevelopment: IPersonalDevelopment) {
        makeAutoObservable(this);
        this.personalDevelopment = personalDevelopment;
    }

    get asJson(): IPersonalDevelopment {
        return toJS(this.personalDevelopment);
    }

    // Method to update career goals
    updateCareerGoals(goals: string) {
        this.personalDevelopment.careerGoals = goals;
    }

    // Method to update skill development plan
    updateSkillDevelopment(plan: string) {
        this.personalDevelopment.skillDevelopment = plan;
    }

    // Method to update improvement areas
    updateImprovementAreas(areas: string) {
        this.personalDevelopment.improvementAreas = areas;
    }

    // Method to update action items
    updateActionItems(items: string) {
        this.personalDevelopment.actionItems = items;
    }

    // Method to update leadership values
    updateLeadershipValues(values: string) {
        this.personalDevelopment.leadershipValues = values;
    }

    // Method to update skill improvement actions
    updateSkillImprovement(actions: string) {
        this.personalDevelopment.skillImprovement = actions;
    }

    // Additional methods can be implemented as needed
}
